<template>
  <div class="flex flex-col w-88">
    <div class="flex items-center justify-between pb-3 border-b border-gray-200">
      <span class="font-medium text-lg">Notifications</span>
      <button
        v-if="notificationStore.hasUnread"
        class="text-sm text-primary cursor-pointer bg-transparent border-none hover:underline"
        @click="markAllRead"
      >
        Mark all as read
      </button>
    </div>

    <div v-if="notificationStore.isLoading" class="py-6 text-center text-surface-500">
      Loading...
    </div>

    <div v-else-if="notificationStore.notifications.length === 0" class="py-6 text-center text-surface-500">
      No notifications
    </div>

    <ul v-else class="list-none p-0 m-0 flex flex-col max-h-96 overflow-y-auto">
      <NotificationItem
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        :notification="notification"
        @click="handleItemClick(notification)"
      />
    </ul>

    <div class="border-t border-gray-200 pt-3 mt-1 text-center">
      <router-link
        :to="{ name: 'my-profile-notifications' }"
        class="text-sm text-primary hover:underline"
        @click="emit('close')"
      >
        View all notifications
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import NotificationItem from './NotificationItem.vue';
import { useNotificationStore } from '@/stores/notification';
import { getNotificationType } from '@/notifications/notificationTypeRegistry';
import { handleRequest } from '@/utils/handleRequest';

const emit = defineEmits(['close']);
const router = useRouter();
const notificationStore = useNotificationStore();

const markAllRead = async () => {
  await handleRequest(() => notificationStore.markAllAsRead());
};

const handleItemClick = (notification) => {
  if (!notification.read_at) {
    handleRequest(() => notificationStore.markAsRead(notification.id));
  }

  const route = getNotificationType(notification.type).resolveRoute(notification);
  if (route) {
    router.push(route);
  }

  emit('close');
};
</script>
